// extracted by mini-css-extract-plugin
export default {"form":"GCvw9hoN","mobile":"mobile","field":"iN7jf6pj","footer":"XwkjUcUR","errorMessage":"_2dF1XYBx"};